<div class="soft-list-item flex flex-row justify-between items-center flex-nowrap">
  <div class="flex flex-col justify-center text-truncate w-auto!">
    <span class="text-sm color-light">
      {{ '#TRANSPORT.STATION_DETAIL.INPUT.ITEM_NUMBER_PREFIX' | translate }}
      {{ item()?.artikel?.artikelnummer }}
    </span>
    <strong>
      @if (item()?.artikel?.bezeichnung && item()?.artikel?.bezeichnung !== '') {
        {{ item()?.artikel?.bezeichnung }}
      } @else {
        {{ '#TRANSPORT.STATION_DETAIL.INPUT.NO_NAME' | translate }}
      }
    </strong>
    <span class="text-sm">
      vorgeschlagene Menge: {{ originalItem()?.menge ?? 1 | number: '1.0-2' }}
    </span>
  </div>
  <div class="grid grid-cols-[4.5rem_2rem_2rem] ml-2 justify-items-end items-center">
    @if (editable()) {
      <label for="">
        <soft-number-input
          [id]="'numberInput' + index()"
          [value]="
            item()?.menge === originalItem()?.menge ? null : (item()?.menge ?? null)
          "
          class="align-right"
          placeholder="{{ $safeNavigationMigration(originalItem()?.menge) | number: '1.0-2' }}"
          (gotFocus)="scrollToTop('numberInput' + index())"
          (valueChange)="quantityChange.emit($event ?? 0)"
        />
      </label>
    } @else {
      <span class="mr-2">{{ item()?.menge || 0 | number: '1.0-2' }}</span>
    }

    <span>{{ item()?.arteh?.arteh }}</span>
    @if ($safeNavigationMigration(item()?.id) === undefined) {
      <span class="cursor-pointer" (click)="delete.emit()">
        <i class="fa-regular fa-trash text-danger"></i>
      </span>
    }
  </div>
</div>
